import React, { useState, useEffect } from 'react';

function CategoriesProduct() {
    const urlImg = "https://dev.jftheskinspecialist.com/images/news/";

    const [acneList, SetAcneList] = useState([]);
    const [dermaList, SetDermaList] = useState([]);

    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/acneseries')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetAcneList(datas.data);
        });
    
        fetch('https://dev.jftheskinspecialist.com/api/dermaseries')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetDermaList(datas.data);
            });

    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <div class="max-w-full mx-auto bg-[#fefaed]">
            <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                <div class="w-full bg-[#fd9401]">
                    <div><br /><br /><br /><br /></div>
                    <h1 class="text-center pt-5"><span style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded300', fontSize: 43 }}>ANTI</span><span style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded900', fontSize: 43 }}>ACNE</span>
                        <span style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded300', fontSize: 43 }}>SERIES</span></h1>

                    {acneList.map((acne, index_acne) => (
                        <div key={index_acne}>
                            <p class="text-lg text-center mb-8 p-10 leading-relaxed lg:w-[620px] mx-auto" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 18, fontWeight: 'bold' }}>
                                {getLang === 'id' ? 
                                    <div dangerouslySetInnerHTML={{ __html: acne.content }}></div>
                                :
                                    <div dangerouslySetInnerHTML={{ __html: acne.content_en }}></div>
                                }
                            </p>
                        </div>
                    ))}

                    {acneList.map((image_acne, index_acne_image) => (
                        <div class="flex justify-center" key={index_acne_image}>
                            <img src={urlImg + '' + image_acne.featured_image} class="lg:h-[480px]" alt="" />
                        </div>
                    ))} 
                </div>

                <div class="w-full bg-[#fed857]">
                    <div><br /><br /><br /><br /></div>
                    <h1 class="text-center pt-5"><span style={{ color: '#4B4A49', fontFamily: 'MuseoSansRounded900', fontSize: 38 }} >DERMA</span> <span style={{ color: '#4B4A49', fontFamily: 'MuseoSansRounded300', fontSize: 38 }}>SERIES</span></h1>
                    
                    {dermaList.map((derma, index_derma) => (
                        <div key={index_derma}>
                            <p class="text-lg text-center mb-8 p-10 leading-relaxed lg:w-[620px] mx-auto" style={{ color: '#4B4A49', fontFamily: 'MuseoSansRounded900', fontSize: 18, fontWeight: 'bold' }}>
                                {getLang === 'id' ?
                                    <div dangerouslySetInnerHTML={{ __html: derma.content }}></div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: derma.content_en }}></div>
                                }
                            </p>
                        </div>
                    ))}

                    {dermaList.map((image_derma, index_acne_derma) => (
                        <div class="flex justify-center" key={index_acne_derma}>
                            <img src={urlImg + '' + image_derma.featured_image} alt="" class="lg:h-[485px]" />
                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
}

export default CategoriesProduct;
